import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip } from 'recharts';
import AnalyticsEmptyState from "../../dashboard/AnalyticsEmptyState";
import { CHART_MARK_STROKE, CHART_MARK_STROKE_WIDTH } from '../../../helpers/chartPalette';

const HomeMultipleBarChart = ({data, otherInputs}) => {

  if (!data || data.length === 0) {
    return <AnalyticsEmptyState />;
  }

      const getPath = (x, y, width, height) => {
        return `M${x},${y}
        L${x + width},${y}
        L${x + width},${y + height}
        L${x},${y + height}
        Z`;
      };
      
      const TriangleBar = (props) => {
        const { fill, x, y, width, height } = props;
      
        return <path d={getPath(x, y, width, height)} stroke="none" fill={fill} />;
      };

      const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
          if(label === 'Anders'){
            return (
              <div className="custom-tooltip">
                <p className="label">{`${label}: ${payload[0].value}`}</p>
                <p className="label">{`Reacties:`}</p>
                <ul>
                  {otherInputs && otherInputs.map(input => (
                    <li>{input}</li>
                  ))}
                </ul>
              </div>
            );
          }
          return (
            <div className="custom-tooltip">
              <p className="label">{`${label} : ${payload[0].value}`}</p>
            </div>
          );
        }
      
        return null;
      };

  return (
    <ResponsiveContainer width="100%" height={300}>
        <BarChart
            data={data && data.length > 0 ? data : [{name: 'No data', uv: 0}]}
            margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
            }}
        >
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip content={<CustomTooltip />}/>

            <Bar dataKey="score" shape={<TriangleBar />} label={{ position: 'top' }} stroke={CHART_MARK_STROKE} strokeWidth={CHART_MARK_STROKE_WIDTH}>
            {data ? data.map((entry, index) => (
               <Cell
               key={`cell-${index}`}
               fill={entry.color}
            stroke={CHART_MARK_STROKE} strokeWidth={CHART_MARK_STROKE_WIDTH} />
            ))
            : null}
            </Bar>
        </BarChart>
    </ResponsiveContainer>
  )
}

export default HomeMultipleBarChart